import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {EVIDENCE_ALLOWED_TYPES, EVIDENCE_MAX_BYTES, evidenceTooBig} from '@/hooks/sgsst/evidencias/use-evidence'

export function useLicenciaFilePicker(setError: (message: string | null) => void) {
  const {t} = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  function pickFile(picked: File | null | undefined) {
    if (!picked) return
    if (!EVIDENCE_ALLOWED_TYPES.has(picked.type)) {
      setError(t('errors.evidenceBadFormat'))
      return
    }
    if (picked.size > EVIDENCE_MAX_BYTES) {
      setError(evidenceTooBig(t, picked))
      return
    }
    setError(null)
    setFile(picked)
  }

  return {file, pickFile}
}
